import { randomPlainString } from '@lib/random';
import { between } from '@lib/utils';
import { separate } from './separate';

export function initials(text: boolean | string, sep = ' ', chars = 2): string {
    if (!text) {
        return '';
    }

    if (text === true) {
        return randomPlainString(chars * 2)
            .replace(/[-_]/g, '')
            .substr(0, chars);
    }

    const words$ = separate(text, sep);
    const chars$ = between(chars, 1, words$.length);

    let initials$ = '';

    for (let i = 0; i < chars$; i++) {
        initials$ += words$[i][0] || '';
    }

    return initials$;
}
